import React from 'react'

import './FormTextDescription.scss'

export default function FormTextDescription({ children, align }) {
  return (
    <div className="FormTextDescription">
      <div className={`body2 ${align}`}>{children}</div>
    </div>
  )
}
